export const toasterConfig = {
    position: "top-right",
    autoClose: 3000,
    hideProgressBar: "false",
    closeOnClick: "true",
    pauseOnHover: "true",
    draggable: "true",
    progress: "undefined",
    theme: "colored",
    transition: "Slide",
};

export function formatAmount(amount) {
    return amount.toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });
}

export function numberToWords(num) {
    const units = ["", "one", "two", "three", "four", "five", "six", "seven", "eight", "nine"];
    const teens = [
        "ten",
        "eleven",
        "twelve",
        "thirteen",
        "fourteen",
        "fifteen",
        "sixteen",
        "seventeen",
        "eighteen",
        "nineteen",
    ];
    const tens = [
        "",
        "",
        "twenty",
        "thirty",
        "forty",
        "fifty",
        "sixty",
        "seventy",
        "eighty",
        "ninety",
    ];

    function convertHundreds(num) {
        let result = "";

        if (num >= 100) {
            result += units[Math.floor(num / 100)] + " hundred ";
            num %= 100;
        }

        if (num >= 10 && num < 20) {
            result += teens[num - 10] + " ";
        } else {
            if (num >= 20) {
                result += tens[Math.floor(num / 10)] + " ";
                num %= 10;
            }
            if (num > 0) {
                result += units[num] + " ";
            }
        }

        return result.trim();
    }

    function capitalizeWords(str) {
        return str.replace(/\b\w/g, (char) => char.toUpperCase());
    }

    if (num === 0) return "Zero";

    let result = "";

    if (num >= 1000) {
        result += convertHundreds(Math.floor(num / 1000)) + " thousand ";
        num %= 1000;
    }

    result += convertHundreds(num);

    return capitalizeWords(result.trim());
}
